import log from "loglevel";
import React from "react";
import ReactDOM from "react-dom/client";
import AppProvider from "./AppProvider";
import AppRoutes from "./AppRoutes";
import "./index.css";
import Env from "./core/config/env";
import { queryClient } from "./core/queryClient";
import { prefetchOnBoot, preloadShellChunks } from "./core/boot/prefetchOnBoot";
import { startPanelLoadTiming } from "./features/panel-load-timing/utils/panelLoadTiming";

// Nível de log por ambiente: prod=error, staging=info, dev=debug.
switch (Env.VITE_ENV) {
  case "prod": {
    log.setLevel("error");
    break;
  }
  case "staging": {
    log.setLevel("info");
    break;
  }
  default: {
    log.setLevel("trace");
    break;
  }
}

// SA-1469: rota de entrada e TTFB para o tempo de carregamento em produção.
startPanelLoadTiming();

// SA-1452: com sessão guardada, as queries do F5 e os chunks do shell saem
// antes do React montar, em paralelo (ver `prefetchOnBoot`).
prefetchOnBoot(queryClient, window.location.pathname);
preloadShellChunks(window.location.pathname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.Fragment>
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  </React.Fragment>
);
